import {
    getTags,
    deleteTag,
    getShowTag,
    updateTag,
    createTag
} from '../../api/tagsApi'
import {createCategory, deleteCategory, getShowCategory, updateCategory} from "../../api/categoryApi";
import {Message} from "element-ui";
import router from "../../router";

const state = {
    tags: [],
    tag: {}
}

const getters = {
    getTags: state => state.tags,
    getShowTag: state => state.tag
}

const mutations = {
    SET_TAGS: (state, payload) => {
        state.tags = payload.data
    },
    SET_TAG_SHOW: (state, payload) => {
        state.tag = payload
    },
}

const actions = {
    getTags: ({commit}, params) => {
        getTags(params).then(resp => {
            commit('SET_TAGS', resp)
        }).catch(err => console.log(err))
    },
    deleteTag: ({dispatch}, id) => {
        deleteTag(id).then(r => {
            Message({
                message: 'Tag has been deleted',
                type: 'success',
                duration: 5 * 1000,
                showClose: true,
            })
        })
    },
    getShowTag: ({commit, dispatch}, idTag) => {
        getShowTag(idTag).then(r => {
            commit('SET_TAG_SHOW', r.data)
        }).catch(err => {
            if (err.response.status === 404) {
                console.log(router.push({name: 'not-found'}))
            }
        })
    },
    updateTag: ({commit}, payload) => {
        updateTag(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
    createTag: ({commit}, payload) => {
        createTag(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
    clearCurrentTag: ({commit}) => {
        commit('SET_TAG_SHOW', { logo_name: '' } )
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
